import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const showFbShares: AdminBlockTypeAttribute = {
  label: 'Show FB shares',
  key: 'showFbShares',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default showFbShares;
